/* eslint-disable @typescript-eslint/no-explicit-any */
import { WfBranchSummaryResponse } from '../../models/WfSummary';

export const calculateTotalSummary = (
  data: WfBranchSummaryResponse[],
  nameOverride: string
): WfBranchSummaryResponse => {
  const totals = data.reduce(
    (acc, curr) => {
      return {
        products: (acc.products || 0) + (curr.products || 0),
        confinement: {
          incidentItems:
            (acc.confinement?.incidentItems || 0) + (curr.confinement?.incidentItems || 0),
          completedItems:
            (acc.confinement?.completedItems || 0) + (curr.confinement?.completedItems || 0),
        },
        currentSituation: {
          alert: (acc.currentSituation?.alert || 0) + (curr.currentSituation?.alert || 0),
          onCall: (acc.currentSituation?.onCall || 0) + (curr.currentSituation?.onCall || 0),
          outage: (acc.currentSituation?.outage || 0) + (curr.currentSituation?.outage || 0),
          otherAlerts:
            (acc.currentSituation?.otherAlerts || 0) + (curr.currentSituation?.otherAlerts || 0),
          parts: (acc.currentSituation?.parts || 0) + (curr.currentSituation?.parts || 0),
          flood: (acc.currentSituation?.flood || 0) + (curr.currentSituation?.flood || 0),
          inaccessible:
            (acc.currentSituation?.inaccessible || 0) + (curr.currentSituation?.inaccessible || 0),
          recovered:
            (acc.currentSituation?.recovered || 0) + (curr.currentSituation?.recovered || 0),
        },
      };
    },
    { confinement: {}, currentSituation: {} } as any
  );

  totals.confinement.completedRate =
    totals.confinement.incidentItems > 0
      ? (totals.confinement.completedItems / totals.confinement.incidentItems).toString()
      : '0';

  totals.branchCode = '';
  totals.branchName = nameOverride;
  totals.salesOfficeName = '';
  totals.salesOfficeCode = '';

  return totals;
};
